import { FEATURED_CAPABILITIES } from "@/data/content";
import { Reveal, ChapterBadge } from "@/components/Reveal";

export default function FeaturedRole() {
  return (
    <section data-testid="featured-role-section" className="py-20 sm:py-28 bg-charcoal-900 text-parchment">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ChapterBadge number="04" label="Current Role — In Focus" light />

        <div className="mt-10 grid lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-5">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]">
              Creative Operations <em className="italic text-copper-500">in action.</em>
            </h2>
            <div className="mt-8 border-l-2 border-copper-500 pl-6">
              <p className="font-mono text-xs tracking-[0.2em] uppercase text-parchment/50">Present</p>
              <p className="mt-2 text-xl font-semibold">Sr. Manager – Creative &amp; Content Operations</p>
              <p className="mt-1 text-parchment/70">Sriveda Sattva Pvt. Ltd. | Sri Sri Tattva</p>
              <p className="mt-1 font-mono text-xs text-parchment/50">April 2026 – Present · Bengaluru</p>
            </div>
            <p className="mt-8 text-base leading-relaxed text-parchment/70">
              Owning the complete creative and content engine for an FMCG brand — from social and
              campaign creative to institutional communication, production workflows, teams and
              vendors.
            </p>
          </Reveal>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {FEATURED_CAPABILITIES.map((cap, i) => (
              <Reveal key={cap.title} delay={Math.min(i * 0.05, 0.35)}>
                <div
                  data-testid={`featured-capability-${i}`}
                  className="h-full rounded-xl border border-parchment/10 bg-parchment/[0.03] p-5 hover:border-copper-500/50 hover:bg-parchment/[0.06] transition-[border-color,background-color] duration-300"
                >
                  <h3 className="text-[15px] font-semibold text-parchment">{cap.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-parchment/60">{cap.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
